import client from "config/agent"
import { DataVisualizationInitialData } from "types/data-visualization.types"

export interface InitialDataResult {
  loading: boolean
  error: boolean
  data: DataVisualizationInitialData | null
}

export class DataVisualizationInitialService {
  /**
   * Fetch initial data for data visualization page
   * @returns Promise with initial data (companies, addresses, zones)
   */
  async fetchInitialData(): Promise<InitialDataResult> {
    try {
      const response = await client.get("/data-visualization/initial-data")

      return {
        loading: false,
        error: false,
        data: response.data,
      }
    } catch (error) {
      console.error("Error fetching initial data:", error)

      // For development/testing, return mock data
      if (process.env.NODE_ENV === "development" || process.env.REACT_APP_STAGE === "development") {
        console.log("Using mock initial data for development")
        return {
          loading: false,
          error: false,
          data: {
            companies: [],
            companyAddresses: [],
            companyAddressZones: [],
          },
        }
      }

      return {
        loading: false,
        error: true,
        data: null,
      }
    }
  }
}

// Export singleton instance
export const dataVisualizationInitialService = new DataVisualizationInitialService()
